import { render, staticRenderFns } from "./PurchaseHistoryTable.vue?vue&type=template&id=e1a7c148"
import script from "./PurchaseHistoryTable.vue?vue&type=script&lang=ts"
export * from "./PurchaseHistoryTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports